export enum GarrisonType {
    WarlordsOfDraenor = 2,
    Legion = 3,
    BattleForAzeroth = 9,
    Shadowlands = 111,
}
